// Backoffice, Etapa G - matriz oficial DEMANDA + STATUS -> ACOES
// (transicoes) PERMITIDAS na UI. Isto e SO apresentacao (quais botoes
// mostrar), igual ao restante de statusMeta.js - a validacao real de toda
// transicao continua so no backend (api/src/constants/statusTransitions.ts),
// sempre. Divergir daqui so muda um botao a mais/a menos na tela, nunca uma
// transicao aplicada sem passar pela validacao do backend.
//
// Chave = nome EXATO do tipo de demanda (RequestType.name), a mesma string
// que a API devolve em `solicitacao.type.name`. So demandas com regra de
// negocio JA DEFINIDA aparecem aqui - as outras 33 (ainda sem definicao)
// caem no fallback generico (GENERIC_TRANSITIONS, o mesmo comportamento
// que ja existia antes desta etapa) atraves de transitionsForDemand().
// Nao inventar regra para nenhuma demanda que nao esteja listada aqui -
// ver docs/whaticket/integration.md, secao Backoffice/Etapa G, para o
// levantamento completo do que ainda falta definir.
const DEMAND_TRANSITIONS = {
	"Abertura Conta PF (Investimentos)": {
		created: ["in_progress", "cancelled"],
		in_progress: ["waiting_btg", "waiting_assessor_client", "completed", "cancelled"],
		waiting_btg: ["in_progress", "completed", "btg_refused", "cancelled"],
		waiting_assessor_client: ["in_progress"],
		btg_refused: ["completed"],
		completed: [],
		cancelled: [],
	},
};

// Comportamento generico/atual - identico ao fluxo aprovado para "Abertura
// Conta PF (Investimentos)" (a unica demanda com regra definida ate agora),
// usado como fallback para as 33 demandas restantes ate que cada uma seja
// definida com o negocio.
export const GENERIC_TRANSITIONS = {
	created: ["in_progress", "cancelled"],
	in_progress: ["waiting_btg", "waiting_assessor_client", "completed", "cancelled"],
	waiting_btg: ["in_progress", "completed", "btg_refused", "cancelled"],
	waiting_assessor_client: ["in_progress"],
	btg_refused: ["completed"],
	completed: [],
	cancelled: [],
};

// true so para as demandas que ja tem uma linha propria na matriz - usado
// so para diagnostico/log, nunca para decisao de seguranca.
export const hasSpecificMatrix = demandName => Boolean(demandName && DEMAND_TRANSITIONS[demandName]);

export const transitionsForDemand = demandName =>
	(demandName && DEMAND_TRANSITIONS[demandName]) || GENERIC_TRANSITIONS;
